import React from 'react'
import EditPurchase from "./PurchaseActions/EditPurchase";
import DeletePurchase from "./PurchaseActions/DeletePurchase";
import ClosePurchase from "./PurchaseActions/ClosePurchase";
import DetailPurchase from "./PurchaseActions/DetailPurchase";
import PurchasePrintContainer from "./print/PurchasePrintContainer";

const PurchaseActions = ({record}) => {

    return (
        <React.Fragment>
            <div style={{marginLeft: '-12px'}}>
                <ClosePurchase record={record}/>
                <EditPurchase record={record}/>
                <DetailPurchase record={record} />
                <PurchasePrintContainer purchaseId={record.id} />
                <DeletePurchase record={record}/>
            </div>
        </React.Fragment>
    )
}
export default PurchaseActions